module.exports = __webpack_public_path__ + "img/5-section-model-xr.c235f57e.jpeg";